import { IEntity } from "@odata/BindingContext";
import { PrTaxpayerDeclarationEntity } from "@odata/GeneratedEntityTypes";
import { getEndOfLastProcessedPeriod } from "@pages/payroll/payroll.utils";
import { TempDateValidToPath } from "@pages/payroll/taxpayerDeclaration/InvalidateDeclaration.def";

import { withPermissionContext } from "../../../../contexts/permissionContext/withPermissionContext";
import DialogFormView, { IDialogFormViewProps } from "../../../../views/formView/DialogFormView";
import { IFormStorageDefaultCustomData, IFormStorageSaveResult } from "../../../../views/formView/FormStorage";

export interface InvalidateDeclarationFormViewCustomData extends IFormStorageDefaultCustomData {
    minDateForInvalidateDeclaration?: Date;
}

interface IProps extends IDialogFormViewProps<IEntity, InvalidateDeclarationFormViewCustomData> {
}

class InvalidateDeclarationFormView extends DialogFormView<IEntity, IProps> {
    async onAfterLoad(): Promise<void> {
        const endOfLastWageDate = await getEndOfLastProcessedPeriod(this.props.storage);
        this.props.storage.setCustomData({
            minDateForInvalidateDeclaration: endOfLastWageDate
        });
        return super.onAfterLoad();
    }

    save = async (): Promise<IFormStorageSaveResult> => {
        const { storage } = this.props;
        const validationRes = await storage.validateAll();
        if (validationRes.hasError) {
            storage.refresh();
            return null;
        }

        const dateApplyTo = storage.getValueByPath(TempDateValidToPath);

        this.props.onAfterConfirm({
            [PrTaxpayerDeclarationEntity.DateApplyTo]: dateApplyTo
        });

        return null;
    };
}

export default withPermissionContext(InvalidateDeclarationFormView);